import ErrorBoundary from "@/components/common/ErrorBoundary";
import DataTable from "@/components/datatable/components/DataTable";
import { safeDecompress, tableSearchSchema } from "@/components/datatable/hooks/useTableUrlState";
import { mapTableStateToQueryParams } from "@/components/datatable/utils";
import useIGoldTransactionsQuery from "@/hooks/useIGoldTransactionsQuery";
import { igoldTransactionsKeys } from "@/query-keys";
import { type IGoldTransactionListItem } from "@/schemas/igoldTransactionSchema";
import { services } from "@/services";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import useColumns from "./_hooks/useColumns";

export const Route = createFileRoute("/_private/ateliers/$atelierId/igold-transactions/")({
  validateSearch: tableSearchSchema,
  loaderDeps: ({ search }) => ({
    q: search.q,
  }),
  loader: async ({ deps, params, context: { queryClient } }) => {
    const tableState = safeDecompress(deps.q);
    const extra = new URLSearchParams({
      atelierId: params.atelierId,
    });
    const requestParams = mapTableStateToQueryParams(tableState, extra);
    return queryClient.ensureQueryData({
      queryKey: igoldTransactionsKeys.lists(deps.q, extra.toString()),
      queryFn: () => services.getIGoldTransactions(requestParams),
    });
  },
  component: RouteComponent,
  errorComponent: ({ error }) => (
    <ErrorBoundary error={error} reset={() => window.location.reload()} />
  ),
});

function RouteComponent() {
  const search = Route.useSearch();
  const params = Route.useParams();  const loaderData = Route.useLoaderData();

  const { data: paginatedTransactions } = useIGoldTransactionsQuery({
    q: search.q!,
    initialData: loaderData,
    params,
  });

  const columns = useColumns();
  const { t } = useTranslation();const extra = new URLSearchParams({ atelierId: params.atelierId });

  return (
    <DataTable<IGoldTransactionListItem>
      searchPlaceholder={t("kpis.searchPlaceholder")}
      columns={columns}
      data={paginatedTransactions?.items}
      nextCursor={paginatedTransactions?.nextCursor}
      hasMore={paginatedTransactions?.hasMore}
      queryKey={igoldTransactionsKeys.lists(search.q, extra.toString())}
      navigateFrom="/ateliers/$atelierId/igold-transactions"
      searchFrom="/_private/ateliers/$atelierId/igold-transactions/"      searchable={true}
      noShadow
    />
  );
}
